export const CUSTOM_REACT_COMPONENT_API = "/custom-component";
